import React from "react";

// reactstrap components
import { Button, Container, Row, Col, UncontrolledCarousel } from "reactstrap";

import { MultiLang, Determinator } from "react-multi-language";

const items = [
  {
    src: require("assets_/img_/carousel/CLC_cover_01.jpg"),
    altText: "",
    caption: "",
    header: ""
  },
  {
    src: require("assets_/img_/carousel/CLC_cover_02.jpg"),
    altText: "",
    caption: "",
    header: ""
  },
  {
    src: require("assets_/img_/carousel/CLC_cover_03.jpg"),
    altText: "",
    caption: "",
    header: ""
  },
  {
    src: require("assets_/img_/carousel/CLC_cover_04.jpg"),
    altText: "",
    caption: "",
    header: ""
  },
  {
    src: require("assets_/img_/carousel/CLC_cover_05.jpg"),
    altText: "",
    caption: "",
    header: ""
  },
  {
    src: require("assets_/img_/carousel/CLC_cover_06.jpg"),
    altText: "",
    caption: "",
    header: ""
  },
  {
    src: require("assets_/img_/carousel/CLC_cover_07.jpg"),
    altText: "",
    caption: "",
    header: ""
  },
  {
    src: require("assets_/img_/carousel/CLC_cover_08.jpg"),
    altText: "",
    caption: "",
    header: ""
  },
  // {
  //   src: require("assets_/img_/carousel/CLC_20200716_DSC01959.JPG"),
  //   altText: "",
  //   caption: "",
  //   header: ""
  // },
  // {
  //   src: require("assets_/img_/carousel/CLC_20200716_DSC01969.JPG"),
  //   altText: "",
  //   caption: "",
  //   header: ""
  // },
];

class Carousel extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      // itemsToShow: 3,
      expanded: false,
    };
    this.showMore = this.showMore.bind(this);
  }

  showMore() {
    // this.state.itemsToShow === 3 ? (
    //   this.setState({ itemsToShow: 5, expanded: true })
    // ) : (
    //     this.setState({ itemsToShow: 3, expanded: false })
    //   )
    this.setState({ expanded: !this.state.expanded })
  }

  render() {
    return (
      <>
        {console.log("***** Index.js, Carousel.js [this.props.languageState] ")}
        {console.log(this.props.languageState)}
        <section className="section section-shaped">
          <div className="shape shape-style-1 shape-default">
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
          <Container className="py-md">
            <br />
            <br />
            <Row className="justify-content-between align-items-center">
              <br />
              <Col className="mb-5 mb-lg-0" lg="5">
                <h6 className="text-white font-weight-light">
                  <Determinator>
                    {{
                      en: "Relocation of Sha Tin Sewage Treatment Works to Caverns –",
                      tw: "搬遷沙田污水處理厰往岩洞 –",
                      cn: "搬迁沙田污水处理厂往岩洞 –",
                    }}
                  </Determinator>
                </h6>
                <h2 className="text-white font-weight-light">
                  <Determinator>
                    {{
                      en: "Community Liaison Centre (CLC)",
                      tw: "社區聯絡中心",
                      cn: "社区联络中心",
                    }}
                  </Determinator>
                </h2>

                {/* <Button
                  className="btn-white mt-4"
                  color="default"
                  href="https://demos.creative-tim.com/argon-design-system-react/#/documentation/alerts?ref=adsr-landing-page"
                >
                  See all components
                </Button> */}
              </Col>
              <Col className="mb-lg-auto" lg="6">
                <div className="rounded shadow-lg overflow-hidden transform-perspective-right">
                  <UncontrolledCarousel items={items} />
                </div>
              </Col>
            </Row>
            <Row className="justify-content-between align-items-center">
              <Col>
                <p className="lead text-white mt-4">
                  <Determinator>
                    {{
                      en: "CLC is ...",
                      tw: "社區聯絡中心是 ...",
                      cn: "社区联络中心是 ...",
                    }}
                  </Determinator>
                </p>
                <p className="lead text-white mt-4 text-align-justify">
                  <Determinator>
                    {{
                      en: "To facilitate the communication of the project with the public and to better serve the society, The Project: “Relocation of Sha Tin Sewage Treatment Works to Caverns”, managed under Drainage Services Department (DSD), had built this CLC adjacent to Mui Tsz Lam Road.",
                      tw: "為促進工程項目與公衆的溝通及更好地服務社區，渠務署管轄下的工程項目：「搬遷沙田污水處理廠往岩洞」，特別於梅子林路旁建造了本社區聯絡中心。",
                      cn: "为促进工程项目与公众的沟通及更好的地服务社区，渠务署认可的下一个工程项目：“搬迁沙田污水处理厂往岩洞”，特别在梅子林路旁建造了本社区联络中心。",
                    }}
                  </Determinator>

                  {this.state.expanded ? (
                    <div>
                      <br />
                      <Determinator>
                        {{
                          en: "The construction of CLC main building adopted innovative construction methodology: Modular Integrated Construction (MiC) and integrated with Building Information Modelling (BIM), which shortened the construction time, improved the accuracy of material estimation and reduced wastage.",
                          tw: "社區聯絡中心的建築採用了創新的「組裝合成」建築法(MiC)建造，配合「建築資訊模型」(BIM)技術，減省建造工時，又可準確計算工料，避免浪費建築物料。",
                          cn: "社区联络中心的建筑采用了创新的「组装合成」建筑法（MiC）建造，配合「建筑资讯模型」（BIM）技术，减省建造工时，又可准确计算工料，避免浪费建筑物料。",
                        }}
                      </Determinator>
                      <br />
                      <Determinator>
                        {{
                          en: "There is a resting garden outside the main building with pavilion and benches installed, trees and shrubs planted, surrounded by mountains and nullah. The local residents and tourists can enjoy this comfortable area and punch hotspot.",
                          tw: "建築的外圍是一個環境幽美的社區公園，亭台樓閣，紅花金柳，青山環繞，綠水長流，為居民及遊人提供了一個舒適的休憩及打卡地點。",
                          cn: "建筑的外围是一个环境幽美的社区公园，亭台楼阁，红花金​​柳，青山环绕，绿水长流，为居民及游人提供了一个舒适的休憩及打卡地点。",
                        }}
                      </Determinator>
                      <br />
                      <br />
                      <Determinator>
                        {{
                          en: "In order to enhance the community’s interaction, public can get the latest project information by visiting the exhibition and join diverse activities held by CLC. Venue booking request from eligible organisations are also welcomed. Let’s build the harmony community together.",
                          tw: "大家除了可以透過參觀中心展覽，取得最新工程資訊，亦可參加中心內舉辦的不同活動，促進社區交流。本中心更歡迎合資格的團體借用中心設施，一起為共建和諧社區而努力。",
                          cn: "大家除了可以透过参观中心展览，取得最新工程资讯，还能参加中心内举行的不同活动，促进社区交流。本中心更欢迎合资格的团体借用中心设施，一起为共建和谐社区而努力",
                        }}
                      </Determinator>
                    </div>
                  ) : (
                      <br />
                    )
                  }
                </p>

                <br />
                <div className="text-align-center">
                  <a href="#" className="text-grey" onClick={this.showMore}>
                    {this.state.expanded ? (
                      <div>
                        ⇡
                      </div>
                    ) : (
                        <div>
                          <Determinator>
                            {{
                              en: "show more",
                              tw: "展開閱讀",
                              cn: "展开阅读",
                            }}
                          </Determinator>
                        </div>
                      )
                    }
                  </a>
                </div>
                <br />
              </Col>
            </Row>
          </Container>
          {/* SVG separator */}
          <div className="separator separator-bottom separator-skew">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon className="fill-white" points="2560 0 2560 100 0 100" />
            </svg>
          </div>
        </section>

        <MultiLang lang={this.props.languageState.lang} />
      </>
    );
  }
}

export default Carousel;
